import axios from 'axios'

class Api {
    constructor() {
        this.state = {
            page: 1,
            limit: 10,
        }
        // eslint-disable-next-line no-undef
        this.apiUrl = process.env.REACT_APP_APIURL
    }

    getLanguages() {
        return new Promise((resolve, reject) => {
            const headers = {
                'accept': 'applications/json',
            }
            axios.get(`${this.apiUrl}/language/list`, { headers })
                .then(({ data }) => resolve(data))
                .catch((error) => reject(error))
        })
    }

    getNews(data) {
        return new Promise((resolve, reject) => {
            const { end, start, token, lang } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/news_list?start=${start}&end=${end}`, {
                    headers,
                })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getCartList(data) {
        return new Promise((resolve, reject) => {
            const { token, lang, order } = data
            const cartListQueryString = this.getCartListQueryString(order)
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/system/cart_list${cartListQueryString}`, {
                    headers,
                })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getCartListQueryString(order) {
        if (!order) order = []
        let cartListQueryString = ''
        order.forEach(({ itemId }, index) => {
            if (index === 0) cartListQueryString += `?_id[]=${itemId}`
            else cartListQueryString += `&_id[]=${itemId}`
        })
        return cartListQueryString
    }

    getFilterQueryString(filters) {
        if (!filters) filters = []
        let filterQueryString = ''
        filters.forEach(({ name, values }) => {
            values.forEach((value) => {
                filterQueryString += `&_filter[${name}]=${encodeURI(value)}`
            })
        })
        return filterQueryString
    }

    getSortQueryString(sort) {
        if (!sort) return 'id'
        else return sort
    }

    getCatalog(data) {
        return new Promise((resolve, reject) => {
            const { end, start, lang, token, filters } = data
            let { sort } = data
            const filterQueryString = this.getFilterQueryString(filters)
            sort = this.getSortQueryString(sort)
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/catalog/list?start=${start}&end=${end}&sort=${sort}${filterQueryString}`, {
                    headers,
                })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getFavorites(data) {
        return new Promise((resolve, reject) => {
            const { end, start, lang, token, filters } = data
            let { sort } = data
            const filterQueryString = this.getFilterQueryString(filters)
            sort = this.getSortQueryString(sort)
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/catalog_favorites?start=${start}&end=${end}&sort=${sort}${filterQueryString}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getModuleEstimates(data) {
        return new Promise((resolve, reject) => {
            const { modId, courseId, token, lang } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/course_estimates?courseId=${courseId}&moduleId=${modId}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getCourseEstimates(data) {
        return new Promise((resolve, reject) => {
            const { courseId, token, lang } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/course_all_estimates?courseId=${courseId}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    search(data) {
        return new Promise((resolve, reject) => {
            const { token, lang, value } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(
                    `${this.apiUrl}/search/${value}`, { headers },
                )
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getGuidance(data) {
        return new Promise((resolve, reject) => {
            const { id, token, lang } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/course_guidance_list/${id}`, {
                    headers,
                })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getCourses(page, limit, lang, accessToken, filters = []) {
        return new Promise((resolve, reject) => {
            const filterQueryString = this.getFilterQueryString(filters)
            const headers = {
                'X-Auth-Token': accessToken,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/course/list?page=${page}&limit=${limit}${filterQueryString}`, {
                    headers,
                })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getUserMain(data) {
        return new Promise((resolve, reject) => {
            const { lang, token } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/user_main`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
    getTeachers(page, limit, lang, accessToken) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': accessToken,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/teachers/list?page=${page}&limit=${limit}`, {
                    headers,
                })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
    getTeacherInfo(id, token, lang) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/teacher/${id}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getStory(page, limit, lang, accessToken) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': accessToken,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/stories/list?page=${page}&limit=${limit}`, {
                    headers,
                })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }



    getCinemas(data) {
        return new Promise((resolve, reject) => {
            const { end, start, token, lang } = data
            let { sort } = data
            if (!sort) sort = 'id'
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/cinemas/list?start=${start}&end=${end}&sort=${sort}`, {
                    headers,
                })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    checkBillStatus(data) {
        return new Promise((resolve, reject) => {
            const { token, billId } = data
            const headers = {
                'X-Auth-Token': token,
            }
            axios
                .get(`${this.apiUrl}/system/cart_bill/${billId}`, {
                    headers,
                })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getProjects(data) {
        return new Promise((resolve, reject) => {
            const { end, start, lang, token, filters } = data
            let { sort } = data
            const filterQueryString = this.getFilterQueryString(filters)
            sort = this.getSortQueryString(sort)
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/project?start=${start}&end=${end}&sort=${sort}${filterQueryString}`, {
                    headers,
                })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getEvents(data) {
        return new Promise((resolve, reject) => {
            const { end, start, lang, token, filters } = data
            let { sort, order } = data
            const filterQueryString = this.getFilterQueryString(filters)
            sort = this.getSortQueryString(sort)
            if (!order) order = 'ASC'
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/event_full?start=${start}&end=${end}&sort=${sort}&order=${order}${filterQueryString}`, {
                    headers,
                })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getTerms(lang, accessToken) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': accessToken,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/terms`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getFaq(data) {
        return new Promise((resolve, reject) => {
            const { lang, token } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/faq`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getWebinars(data) {
        return new Promise((resolve, reject) => {
            const { page, limit, lang, token, sort, order } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/webinar_full?page=${page}&limit=${limit}${sort ? `&sort=${sort}` : ''}${order ? `&order=${order}` : ''}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    postFavorite(data) {
        return new Promise((resolve, reject) => {
            const { catalogId, lang, token } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .post(`${this.apiUrl}/catalog_favorites`, { catalogId }, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    deleteFavorite(data) {
        return new Promise((resolve, reject) => {
            const { catalogId, lang, token } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .delete(`${this.apiUrl}/catalog_favorites/${catalogId}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    checkSubscription(data) {
        return new Promise((resolve, reject) => {
            const { token, lang } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/user_subscription`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getPersonalInfo(data) {
        return new Promise((resolve, reject) => {
            const { token } = data
            const headers = {
                'X-Cabinet-Token': token,
            }
            axios
                .get(`${this.apiUrl}/personal-info`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getSocialNetworks(data) {
        return new Promise((resolve, reject) => {
            const { token } = data
            const headers = {
                'X-Cabinet-Token': token,
            }
            axios
                .get(`${this.apiUrl}/social-links`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    changePersonalInfo(allData) {
        return new Promise((resolve, reject) => {
            const { token, data } = allData
            const headers = {
                'X-Cabinet-Token': token,
            }
            axios
                .put(`${this.apiUrl}/personal-info`, data, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    changeSocialNetworks(allData) {
        return new Promise((resolve, reject) => {
            const { token, data } = allData
            const headers = {
                'X-Cabinet-Token': token,
            }
            axios
                .put(`${this.apiUrl}/social-links`, { data }, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    setUserSettings(data) {
        return new Promise((resolve, reject) => {
            const { token, notifications, location } = data
            const headers = {
                'X-Auth-Token': token,
            }
            axios
                .post(`${this.apiUrl}/user_settings`, { notifications, location }, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    catalogAddToStudy(data) {
        return new Promise((resolve, reject) => {
            const { token, catalogId } = data
            const headers = {
                'X-Auth-Token': token,
            }
            axios.post(`${this.apiUrl}/catalog_add_to_study`, { catalogId }, { headers }).then(({ data }) => {
                resolve(data)
            }).catch((e) => {
                reject(e)
            })
        })
    }

    catalogGetBuyUrl(data) {
        return new Promise((resolve, reject) => {
            const { lang, token, catalogId } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios.post(`${this.apiUrl}/catalog_get_buy_url`, { catalogId }, { headers }).then(({ data }) => {
                resolve(data)
            }).catch((e) => {
                reject(e)
            })
        })
    }

    catalogBuy(data) {
        return new Promise((resolve, reject) => {
            const { token, catalogIds, promo } = data
            const headers = {
                'X-Auth-Token': token,
            }
            axios.post(`${this.apiUrl}/catalog_buy`, { catalogIds, promo }, { headers }).then(({ data }) => {
                resolve(data)
            }).catch((e) => {
                reject(e)
            })
        })
    }

    getCartLink(data) {
        return new Promise((resolve, reject) => {
            const { token, lang, order } = data
            const cartListQueryString = this.getCartListQueryString(order)
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios.get(`${this.apiUrl}/system/cart_link${cartListQueryString}`, {
                headers,
            }).then(({ data }) => {
                resolve(data)
            }).catch((e) => {
                reject(e)
            })
        })
    }

    courseCompleteModule(allData) {
        return new Promise((resolve, reject) => {
            const { token, courseId, modId, lang, data } = allData
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .post(`${this.apiUrl}/course_complete_module`, { courseId, modId, data }, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    writeAvatar(data) {
        return new Promise((resolve, reject) => {
            const { token, base64Image } = data
            const headers = {
                'X-Cabinet-Token': token,
                Accept: 'application/json',
            }
            axios
                .post(`${this.apiUrl}/avatar`, { base64Image }, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    deleteAvatar(data) {
        return new Promise((resolve, reject) => {
            const { token } = data
            const headers = {
                'X-Cabinet-Token': token,
                Accept: 'application/json',
            }
            axios
                .delete(`${this.apiUrl}/avatar`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getUserSettings(data) {
        return new Promise((resolve, reject) => {
            const { token } = data
            const headers = {
                'X-Auth-Token': token,
            }
            axios
                .get(`${this.apiUrl}/user_settings`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getUserStudyHistory(data) {
        return new Promise((resolve, reject) => {
            const { token, lang, start, end, sort, order } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/user_study_history?start=${start}&end=${end}&sort=${sort}&order=${order}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getUserLogs(data) {
        return new Promise((resolve, reject) => {
            const { token, lang, start, end, sort, order } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/user_log?start=${start}&end=${end}&sort=${sort}&order=${order}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    unsubscribe(data) {
        return new Promise((resolve, reject) => {
            const { token, lang } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .delete(`${this.apiUrl}/user_subscription`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    subscribe(data) {
        return new Promise((resolve, reject) => {
            const { token, lang, email } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .post(`${this.apiUrl}/user_subscription`, { email }, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getUserEvents(lang, accessToken) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': accessToken,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/user_event`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getDialogs(accessToken, userId) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': accessToken,
            }
            axios
                .get(`${this.apiUrl}/dialog/${userId}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getProfileImage(accessToken) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': accessToken,
            }
            axios
                .get(`${this.apiUrl}/profile/avatar`, {
                    headers,
                })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getMessages(accessToken, dialogId) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': accessToken,
            }
            axios
                .get(`${this.apiUrl}/dialog_message/${dialogId}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    postMessage(accessToken, from, dialogId, message) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': accessToken,
            }
            axios
                .post(`${this.apiUrl}/dialog_message`, { from, dialogId, message }, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    checkToken(accessToken) {
        return new Promise((resolve, reject) => {
            const headers = {
                accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Auth-Token': accessToken,
            }
            axios.get(`${this.apiUrl}/session`, { headers })
                .then((tokenInfo) => resolve(tokenInfo)).catch((e) => reject(e))
        })
    }

    sendSupportEmail(data) {
        return new Promise((resolve, reject) => {
            const { token, lang, formData } = data
            const headers = {
                accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios.post(`${this.apiUrl}/system/send_support_email`, { formData }, { headers })
                .then((res) => {
                    resolve(res)
                }).catch((e) => {
                    reject(e)
                })
        })
    }

    getGrade(data) {
        return new Promise((resolve, reject) => {
            const { token, lang } = data
            const headers = {
                accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios.get(`${this.apiUrl}/profile/grade`, { headers })
                .then((res) => {
                    resolve(res)
                }).catch((e) => {
                    reject(e)
                })
        })
    }

    getTrainingAssistant(data) {
        return new Promise((resolve, reject) => {
            const { token, lang } = data
            const headers = {
                accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios.get(`${this.apiUrl}/system/training_assistant`, { headers })
                .then((res) => {
                    resolve(res)
                }).catch((e) => {
                    reject(e)
                })
        })
    }

    login(data) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${this.apiUrl}/login`, data)
                .then((data) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getCourseSuccessComplete(data) {
        return new Promise((resolve, reject) => {
            const { courseId, userName, token, lang } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .post(`${this.apiUrl}/course_success_complete`, { courseId, userName }, { headers })
                .then((data) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getUserCertificates(data) {
        return new Promise((resolve, reject) => {
            const { token, lang } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/user_certificates`, { headers })
                .then((data) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getUserMedals(data) {
        return new Promise((resolve, reject) => {
            const { token, lang } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/user_medals`, { headers })
                .then((data) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    profileInfo(accessToken) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': accessToken,
            }
            axios
                .get(`${this.apiUrl}/profile/info`, {
                    headers,
                })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    register(params) {
        return new Promise((resolve, reject) => {
            axios.post(`${this.apiUrl}/register`, params).then(({ data }) => {
                resolve(data)
            }).catch((error) => {
                reject(error)
            })
        })
    }

    passwordRecovery(allData) {
        return new Promise((resolve, reject) => {
            const { email, token, lang } = allData
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .post(`${this.apiUrl}/user_password_recovery`, { email }, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    passwordRecoveryNewPass(allData) {
        return new Promise((resolve, reject) => {
            const { id, email, password, otpCode, token, lang } = allData
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .post(`${this.apiUrl}/user_password_recovery_new_pass`, { id, email, password, otpCode }, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getNewsInfo(id, lang, accessToken) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': accessToken,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/new/${id}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getPageInfo(uri, lang, accessToken) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': accessToken,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/page_full/${uri}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getCourseInfo(id, token, lang) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/course/${id}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getModuleInfo(data) {
        return new Promise((resolve, reject) => {
            const { modId, courseId, token, lang, status = '' } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            const getQuery = status !== '' ? `?status=${status}` : ''
            axios
                .get(`${this.apiUrl}/module/${courseId}/${modId}${getQuery}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getTaskStatus(data) {
        return new Promise((resolve, reject) => {
            const { localId, modId, courseId, token, lang } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/course_task_file/`, { headers, params: { localId, modId, courseId } })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getUserStatus(data) {
        return new Promise((resolve, reject) => {
            const { token, lang } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/user_status`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getConfig() {
        return new Promise((resolve, reject) => {
            axios
                .get(`${this.apiUrl}/system/config`)
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getSystemFrontendSettings(data) {
        return new Promise((resolve, reject) => {
            const { lang } = data
            const headers = {
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/system/frontend`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    sendCourseTaskFile(data) {
        return new Promise((resolve, reject) => {
            const { localId, token, lang, courseId, modId, files, comment } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .post(`${this.apiUrl}/course_task_file/`, { localId, courseId, modId, files, comment }, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getWebinarInfo(data) {
        return new Promise((resolve, reject) => {
            const { id, lang, token } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios.get(`${this.apiUrl}/webinar/${id}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getEventInfo(data) {
        return new Promise((resolve, reject) => {
            const { id, lang, token } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios.get(`${this.apiUrl}/event/${id}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getFilmInfo(id, token, lang) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/films/${id}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getProjectInfo(id, token, lang) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/project/${id}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getItemInfo(data) {
        return new Promise((resolve, reject) => {
            const { id, token, lang } = data
            const headers = {
                'X-Auth-Token': token,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/item/${id}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    getStoryInfo(id, lang, accessToken) {
        return new Promise((resolve, reject) => {
            const headers = {
                'X-Auth-Token': accessToken,
                'Accept-Language': lang,
            }
            axios
                .get(`${this.apiUrl}/story/${id}`, { headers })
                .then(({ data }) => {
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}

export default new Api()



// WEBPACK FOOTER //
// ./src/api/api.js